module.exports = __webpack_public_path__ + "img/prof-dr-hab-Jan-Derezinski.13fbf7b5.jpg";